// Class: motion.easing.Cubic

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Cubic_CubicEaseIn() {return require("./../../motion/easing/_Cubic/CubicEaseIn");}
function motion_easing__$Cubic_CubicEaseInOut() {return require("./../../motion/easing/_Cubic/CubicEaseInOut");}
function motion_easing__$Cubic_CubicEaseOut() {return require("./../../motion/easing/_Cubic/CubicEaseOut");}

// Constructor

var Cubic = function(){}

// Meta

Cubic.__name__ = ["motion","easing","Cubic"];
Cubic.__isInterface__ = false;
Cubic.prototype = {
	
};
Cubic.prototype.__class__ = Cubic.prototype.constructor = $hxClasses["motion.easing.Cubic"] = Cubic;

// Init



// Statics


Cubic.easeIn = new (motion_easing__$Cubic_CubicEaseIn().default)()
Cubic.easeInOut = new (motion_easing__$Cubic_CubicEaseInOut().default)()
Cubic.easeOut = new (motion_easing__$Cubic_CubicEaseOut().default)()

// Export

exports.default = Cubic;